<style scpoed >

.top-margin {
    margin-left: 5px
}

</style>

<template>

<div>

    <el-row>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <channel-select  ref="channelSelect" clearable filterable  @change="channelIdsChange" placeholder="展示渠道"></channel-select>
        </el-form-item>
        <el-form-item  v-if="targetDbtResult == 1">
          <el-select v-model="formInline.target" clearable @change="handleCurrentChange(1)" filterable placeholder="请选择广告位">
            <el-option label="首页顶部banner" :value="1"></el-option>
            <!-- <el-option label="首页中部banner" :value="5"></el-option> -->
            <el-option label="活动专区" :value="4"></el-option>
            <el-option label="本地资讯" :value="6"></el-option>
            <el-option label="资讯流广告" :value="7"></el-option>
            <el-option label="商家页顶部banner" :value="9"></el-option>
            <!--            <el-option label="资讯页顶部banner" :value="10"></el-option>-->
            <el-option label="首页弹窗广告" :value="8"></el-option>
            <el-option label="小程序首页顶部banner" :value="11"></el-option>
            <el-option label="小程序活动专区" :value="12"></el-option>
            <el-option label="首页banner" :value="13"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="targetDbtResult == 2">
          <el-select   v-model="formInline.target" clearable @change="handleCurrentChange(1)" filterable placeholder="请选择广告位">
            <el-option label="首页弹窗广告" :value="8"></el-option>
            <el-option label="本地资讯" :value="6"></el-option>
            <el-option label="首页banner" :value="13"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="targetDbtResult == 3">
          <el-select  v-model="formInline.target" clearable @change="handleCurrentChange(1)" filterable placeholder="请选择广告位">
            <!--            <el-option label="首页顶部banner" :value="1"></el-option>
                       <el-option label="首页中部banner" :value="5"></el-option>
                        <el-option label="活动专区" :value="4"></el-option>

                        <el-option label="资讯流广告" :value="7"></el-option>
                        <el-option label="商家页顶部banner" :value="9"></el-option>
                        <el-option label="资讯页顶部banner" :value="10"></el-option>
                        <el-option label="首页弹窗广告" :value="8"></el-option>
                        <el-option label="小程序首页顶部banner" :value="11"></el-option>
                        <el-option label="小程序活动专区" :value="12"></el-option>-->
            <el-option label="首页弹窗广告" :value="8"></el-option>
            <el-option label="本地资讯" :value="6"></el-option>
            <el-option label="首页banner" :value="13"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="formInline.status" clearable @change="handleCurrentChange(1)" filterable placeholder="请选择上下架">
            <el-option label="上架" :value="1"></el-option>
            <el-option label="下架" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker type="datetimerange" v-model="formInline.startEndTime" start-placeholder="开始时间" placeholder="按发布时间筛选" end-placeholder="结束时间" @change="handleCurrentChange(1)">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="输入关键词按标题搜索" v-model="formInline.title">
            <template slot="append">
              <el-button @click="handleCurrentChange(1)" type="primary">搜索</el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="$router.push({path:'/home/saveThematicDialog'})">新增发布</el-button>
        </el-form-item>
        <el-form-item></el-form-item>
      </el-form>

    </el-row>
    <el-table :data="datas" class="basic-margin" style="width: 100%">
        <el-table-column label="封面图标">
            <template scope="scope">
                <img width="120px" height="120px" :src="scope.row.coverImgURL" class="basic-margin"></img>
            </template>
        </el-table-column>

        <el-table-column label="标题">
            <template scope="scope">
              <span style="color:#303133;">{{scope.row.title}}</span>
            </template>
        </el-table-column>

        <el-table-column label="广告位">
            <template scope="scope">
                <span>{{scope.row.target | bannerTargetFilter}}</span>
            </template>
        </el-table-column>

        <el-table-column v-if="loginInfo.loginPath=='cxh'" prop="createPerson" label="发布人">
        </el-table-column>

        <el-table-column label="发布时间" width="300">
            <template scope="scope">
                <span style="margin-left: 10px;color:#909399;">{{scope.row.createTime|dateTimeFormat }}</span>
            </template>
        </el-table-column>

        <el-table-column label="上下架">
            <template scope="scope">
                <el-tag>{{scope.row.status==0?'下架':'上架'}}</el-tag>
            </template>
        </el-table-column>

        <el-table-column prop="pageViewCount" label="浏览量">
        </el-table-column>

        <el-table-column label="操作" width="250">
            <template scope="scope">
                  <el-button :type="scope.row.status==1?'success':'primary'"  size="small"  v-confirm :confirm-text="scope.row.status==1?'确认下架该banner？':'确认上架该确认下架该banner？？'"  requestUrl="news/changeNewsStatus.action" :confirm-data="{id:scope.row.id,status:scope.row.status==1?0:1}" @onConfirm="loadList()">{{scope.row.status==1?'下架':'上架'}}</el-button>
                  <el-button type="danger"  size="small" @click="deleteNews(scope.row.id)">删除</el-button>
      						<el-button type="warning"  size="small"  @click="$router.push({name:'编辑广告', params: { id: scope.row.id }})" >编辑 </el-button>
            </template>
        </el-table-column>

    </el-table>
    <el-pagination class="row basic-margin" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
    </el-pagination>
</div>

</template>

<script>

import ChannelModel from '../../framework/models/channelModel'
import NewsModel from '../../framework/models/newsModel'
import Config from '../../framework/configs/Config'
import BasicPager from '../../mixins/BasicPager'
import channelSelect from '@/components/channelSelect'
export default {
  name: 'thematic-management',
  extends: BasicPager,
  components: {
    channelSelect
  },
  data: function () {
    return {
      datas: [],
      showChannels: [],
      formInline: {
        target: null,
        showChannelId: null,
        startEndTime: null,
        channelId: null,
        title: null,
        status: null
      },
      targetDbtResult: 1,
      currentPage: 1, // 起始
      pageSize: 10, // 步长
      totalCount: 0, // 总条数
      dialogVisible: false,
      isAdmin: false
    }
  },
  created: function () {
    let userInfo = JSON.parse(localStorage.userInfo)
    let roleName = userInfo.roleName
    switch (roleName) {
      case '汽车网渠道':
        this.targetDbtResult = 1
        break
      case '社群渠道':
      case '加油渠道(单企版)':
      case '加油渠道(平台版)':
      case '二手车+加油渠道(单企版)':
      case '二手车+加油渠道(平台版)':
      case '二手车渠道':
        this.targetDbtResult = 2
        break
      case '汽车网+加油渠道(单企版)':
      case '汽车网+加油渠道(平台版)':
        this.targetDbtResult = 3
        break
    }
  },
  activated: function () {
    let userInfo = JSON.parse(localStorage.userInfo)
    this.isAdmin = userInfo.loginPath != 'channel'
    this.loadList()
    this.findAllChannels()
  },
  methods: {
    channelIdsChange: function (channelId) {
      this.formInline.channelId = channelId
      this.handleCurrentChange(1)
    },

    handleSizeChange () { // 监听页数变化
      this.pageSize = 1
      this.loadList()
    },
    handleCurrentChange (val) { // 监听页码变化
      this.currentPage = val
      this.loadList()
    },
    handleAddSuccess: function () {
      this.loadList()
    },
    handleEditSuccess: function () {
      this.loadList()
    },
    deleteNews: function (id) {
      let _this = this
      this.$confirm('您是否要删除该活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _this = this
        let params = {
          newsId: id
        }
        let listener = {
          success: function (dataInfo) {
            _this.loadList()
            _this.$message({
              type: 'success',
              message: '删除成功'
            })
          }
        }
        NewsModel.deleteNews(this, params, listener)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    findAllChannels: function (channelName) {
      let _this = this

      let listener = {
        success: function (dataInfo) {
          _this.showChannels = dataInfo.datas
        }
      }
      ChannelModel.findAllChannels(_this, listener)
    },
    loadList: function () {
      let _this = this
      let loginInfo = _this.loginInfo

      let params = {
        currentPage: _this.currentPage,
        pageSize: _this.pageSize,
        target: _this.formInline.target,
        status: _this.formInline.status,
        createType: loginInfo.loginPath == 'cxh' ? 1 : 2,
        title: this.formInline.title,
        channelId: loginInfo.loginPath == 'cxh' ? _this.formInline.channelId : loginInfo.id
      }

      if (_this.formInline.startEndTime && _this.formInline.startEndTime.length == 2) {
        let startTime = _this.formInline.startEndTime[0]
        let endTime = _this.formInline.startEndTime[1]
        if (startTime) {
          params.startTime = startTime.getTime()
        }
        if (endTime) {
          params.endTime = endTime.getTime()
        }
      }

      let listener = {
        success: function (dataInfo) {
          for (var i = 0, temp = dataInfo.data.length; i < temp; i++) {
            dataInfo.data[i].coverImgURL = Config.imageUrl + dataInfo.data[i].coverImgURL
          }
          _this.datas = dataInfo.data
          _this.totalCount = dataInfo.recordsTotal
        }
      }

      NewsModel.findNewsList(this, params, listener)
    }
  }
}

</script>
